import React, { Component } from 'react'
import './Alert.css'
import PropTypes from 'prop-types'

export class MergeAlert extends Component {
  static propTypes = {
    onAccept: PropTypes.func,
    onDeny: PropTypes.func,
    loading: PropTypes.bool
  }
  render () {
    const {onAccept, onDeny, loading} = this.props
    return (
      <div className={'adjustmentAlert alert alert-warning'}>
        {loading ? (
          <React.Fragment>Merge in corso...</React.Fragment>
        ) : (
          <React.Fragment>
            Trovati dati utente nel DB, prosegui ad aggiornare i dati?
            <button onClick={onAccept} className="btn btn-info" style={{margin: '0 1.5rem'}}>Si</button>
            <button onClick={onDeny} className="btn btn-warning">No</button>
          </React.Fragment>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Alert/MergeAlert.js